import React, { useState } from "react";
import { HeroSection, AboutSection, TextSection, CtaSection } from "./sections/Basics";
import { ServicesSection, GallerySection, TeamSection, ReviewsSection } from "./sections/Showcase";
import { FaqSection, HoursSection, NewsSection, VideoSection, PagOffersSection, ContactSection } from "./sections/Info";
import { ShopSection } from "./sections/Shop";
import { BookingSection } from "./sections/Booking";
import { ModuleFormSection } from "./sections/ModuleForm";
import { ClientAccessDialog } from "@/components/modules/ClientAccessDialog";

const RENDERERS = { hero: HeroSection, about: AboutSection, services: ServicesSection, shop: ShopSection, gallery: GallerySection, team: TeamSection, reviews: ReviewsSection, faq: FaqSection, hours: HoursSection, news: NewsSection, contact: ContactSection, cta: CtaSection, text: TextSection, video: VideoSection, pag_offers: PagOffersSection, booking: BookingSection, module_form: ModuleFormSection };

// Phase 82/83 — rend les sections de la page courante ; `nav` = contexte de liens (pages, base, ?preview)
export function SectionsRenderer({ payload, slug, sections, nav }) {
  const { site, owner, products, preview } = payload;
  const [access, setAccess] = useState(false);
  const canAccess = site.client_access && owner?.kind === "entreprise";
  return (
    <>
      {sections.map((s) => {
        const C = RENDERERS[s.type];
        return C ? <C key={s.id} section={s} site={site} sections={sections} nav={nav} owner={owner} products={products} shop={site.shop} slug={slug} preview={preview} onClientAccess={canAccess ? () => setAccess(true) : null} /> : null;
      })}
      {canAccess && <ClientAccessDialog open={access} onOpenChange={setAccess} postUrl={`/public/web/${slug}/client-access`} entrepriseName={owner?.name} />}
    </>
  );
}
